<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-space-between align-end">
        <v-flex xs12>
          <h3 class="text-center">View Service Request</h3>
        </v-flex>
        <v-flex xs12 sm5 md5 order-md2 order-sm2 order-xs2>
          <v-card>
            <v-card-title class="py-1">
              <v-spacer></v-spacer>
              Invoices
            </v-card-title>
            <v-card-text>
              <v-data-table :items="invoices" :headers="iheaders" dense>
                <template v-slot:[`item.date`]="{ item }">
                  <inertia-link :href="'/invoices/' + item.id">{{ item.date ? moment(item.date).format('ll') : moment(item.created_at).format('ll') }}</inertia-link>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md6 order-md1 order-sm1 order-xs1>
          <v-card>
            <v-card-title class="py-1">
              <v-spacer></v-spacer>
              <v-btn small icon @click="edit = !edit" title="Edit Details" v-if="!service_request.visit_id || !service_request.professional_id">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <div v-if="edit">
                <form @submit.prevent="editRequest">
                  <v-textarea label="Note" v-model="service_request.note" :rows="2" auto-grow></v-textarea>
                  <v-text-field label="Phone Number" prepend-inner-icon="mdi-cellphone-basic" v-model="service_request.phone" required="required"></v-text-field>
                  <v-btn small type="submit" class="primary pull-right">Update</v-btn><br>
                </form>
              </div>
              <div v-else>
                <p><b>Phone Number</b></p>
                <p v-html="service_request.phone"></p>
                <my-details :detail="['Client Name', service_request.client.name]"></my-details>
                <my-details :detail="['Time', moment(service_request.created_at).format('dddd MMMM D, yyyy H:m')]"></my-details>
                <my-details :detail="['Note', service_request.note]"></my-details>
                <my-details :detail="['Cost', service_request.cost]"></my-details>
                <a download :href="'/' + service_request.file" v-if="service_request.file">Attached File</a>
                <p v-if="service_request.details">
                  <my-details v-for="(detail, title) in service_request.details" :key="title.toString() + Math.random()" :header="sanitize(title)">
                    <p class="my-0" v-for="det, index in detail" :key="index" v-text="det"></p>
                  </my-details>
                </p>
              </div>
              <my-details header="Status">{{ professional ? 'Claimed' : 'Not yet claimed' }}</my-details>
              <v-sheet v-if="professional">
                <my-details header="Claimed By"></my-details>
                <my-details>
                  <inertia-link :href="'/user/professional/' + professional.id">{{ professional.name }}</inertia-link>
                </my-details>
                <my-details>{{ professional.gender }}</my-details>
                <v-img lazy-src="/images/placeholder.gif" :src="'/' + professional.profile_photo_path"></v-img>
              </v-sheet>
              <br>
              <service-request-confirmation :service_request="service_request"></service-request-confirmation>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="py-0">
              <!-- <v-btn small text @click.stop.prevent="rate = !rate">Rate Service</v-btn> -->
              <v-spacer></v-spacer>
              <average-rating-component :ratings="ratings" @userrate="rate = !rate"></average-rating-component>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <mk-dialog v-model="rate">
        <template #title>Rate the service you received</template>
        <template>
          <rate-service-request :errors="errors" :service_request="service_request" @saved="rate = false"></rate-service-request>
        </template>
      </mk-dialog>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/User'
  const MyDetails = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/details.vue')
  const MkDialog = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/mk-dialog')
  const RateServiceRequest = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "service-requests" */ '@/Components/ServiceRequest/createRating')
  const AverageRatingComponent = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "ratings" */ '@/Components/Ratings/averageRating')
  const ServiceRequestConfirmation = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "service-requests" */ '@/Components/ServiceRequest/components/confirmation')

  export default {
    name: 'ViewRequest',
    layout,
    props: [
      'service_request', 'user', 'client', 'pay', 'professional', 'errors'
    ],
    components: {
      MyDetails,
      MkDialog,
      RateServiceRequest,
      AverageRatingComponent,
      ServiceRequestConfirmation,
    },
    metaInfo () {
      return {
        title: 'View Service Request',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        edit: false,
        iheaders: [
          {
            text: 'Date', value: 'date'
          },
          {
            text: 'Amount', value: 'amount'
          },
          {
            text: 'Status', value: 'status'
          }
        ],
        rating: {},
        rate: false,
      }
    },
    methods: {
      editRequest () {
        this.$inertia.put('/service_requests/' + this.service_request.id, this.service_request, {
          preserveScroll: true,
          onSuccess: () => {
            this.edit = false,
            swal({ title: 'Saved', type: 'success', timer: 5000 })
          }
        })
      },
      findUnpaidInvoices () {
        let invoices = this.invoices
        let unpaid = invoices.filter((inv) => {
          return inv.status != 'PAID' && inv.net > 0
        })
        if (unpaid.length > 0) {
          if (unpaid.length === 1) {
            this.$inertia.visit('/invoices/' + unpaid[0].id + '?redirect=' + location.href)
          }
        }
      },
      sanitize (title) {
        try {
          return title.toTitleCase()
        } catch (error) {
          console.error(error);
          return title
        }
      }
    },
    computed: {
      invoices () {
        return this.service_request.invoices
      },
      ratings () {
        return this.service_request.ratings
      }
    },
    mounted () {
      this.$nextTick(() => {
        if (this.pay) {
          this.findUnpaidInvoices()
        }
      })
    }
  }
</script>
